import {
  primaryColor,
  dangerColor,
  successColor,
  grayColor,
  defaultFont
} from "assets/jss/material-kit-react.js";

const customInputStyle = {
  disabled: {
    "&:before": {
      borderColor: grayColor
    }
  },
  underline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: primaryColor,
      borderWidth: "1px !important"
    },
    "&:after": {
      borderColor: primaryColor + " !important"
    }
  },
  underlineError: {
    "&:after": {
      borderColor: dangerColor
    }
  },
  underlineSuccess: {
    "&:after": {
      borderColor: successColor
    }
  },
  whiteUnderline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: "#000000"
    },
    "&:after": {
      borderColor: "#000000"
    }
  },
  labelRoot: {
    ...defaultFont,
    color: primaryColor,
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    top: "10px",
    letterSpacing: "unset",
    "& + $underline": {
      marginTop: "0px"
    }
  },
  labelRootError: {
    color: dangerColor + " !important"
  },
  labelRootSuccess: {
    color: successColor + " !important"
  },
  formControl: {
    margin: "0 0 17px 0",
    paddingTop: "27px",
    position: "relative",
    "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
      color: "#000000"
    }
  },
  input: {
    color: "#000000",
    height: "unset",
    "&,&::placeholder": {
      fontSize: "14px",
      fontFamily: '"AdihausDIN", "Helvetica", "Arial", sans-serif',
      fontWeight: "400",
      lineHeight: "1.42857",
      opacity: "1"
    },
    "&::placeholder": {
      color: "#AAAAAA"
    }
  },
  whiteInput: {
    "&,&::placeholder": {
      color: "#000000",
      opacity: "1"
    }
  }
};

export default customInputStyle;
